// File: src/blueprint/components/content/shared/ContextBlocks.jsx

import BlockRenderer from '../renderers/BlockRenderer.jsx';

function asArray(v) {
  return Array.isArray(v) ? v : [];
}

export default function ContextBlocks({ item }) {
  const context = item?.context && typeof item.context === 'object' ? item.context : null;
  const blocks = asArray(context?.blocks);

  if (!blocks.length) return null;

  return (
    <div className="dv-br-context-blocks" style={{ marginTop: 16 }}>
      {blocks.map((block, index) => (
        <BlockRenderer key={block?.id || `ctx-${index}`} block={block} />
      ))}
    </div>
  );
}
